import { useWorkspaceStore } from 'src/features/workspace/store/useWorkspaceStore';
import { useAuth } from 'src/shared/hooks/use-auth';

export function useWorkspaceAccess() {
  const workspace = useWorkspaceStore((state) => state.workspace);
  const members = workspace.members || [];
  const guests = workspace.guests || [];
  const owner = workspace.owner;

  const myUser = useAuth((s) => s.userDetails);

  const isOwner = owner?.email === myUser?.email;
  const myWSMember = [...members, ...guests, { access: 'full', member: owner }].find(
    (member) => member?.member?.email === myUser?.email
  );

  const isViewer = !myWSMember || (!isOwner && myWSMember?.access === 'view');
  const isEditor = !isOwner && myWSMember?.access === 'edit';
  const isFullAccess = isOwner || myWSMember?.access === 'full';

  return {
    isOwner,
    isViewer,
    isEditor,
    isFullAccess,
  };
}
